<div appBsModal
     #mySettingsModal="bs-modal"
     (onShown)="onShown()"
     class="modal fade"
     tabindex="-1"
     role="dialog"
     aria-labelledby="myLargeModalLabel"
     aria-hidden="true"
     [config]="{backdrop: 'static'}">
    <div class="modal-dialog modal-lg">
        <div class="modal-content">
            <div class="modal-header">
                <h5 class="modal-title">
                    <span>{{"MyProfile" | localize}}</span>
                </h5>
                <button type="button"
                        class="close"
                        [attr.aria-label]="l('Close')"
                        (click)="close()">
                    <i aria-hidden="true"
                       class="ki ki-close"></i>
                </button>
            </div>
            <div class="modal-body"
                 *ngIf="user">
                <tabset>
                    <tab heading="{{'UserDetails' | localize}}">
                        <app-user-details
                            [staff]="user"
                            [ownDetailsEdit]="true">
                        </app-user-details>
                    </tab>

                    <tab *ngIf="user.staffUserRole.staffRole === 1 || user.staffUserRole.staffRole === 2"
                         heading="{{'DirectReports' | localize}}">
                        <div style="padding: 1em; padding-bottom: 2.5em;">
                            <app-direct-reports
                                [staff]="user"
                                [ownDetailsEdit]="true">
                            </app-direct-reports>
                        </div>
                    </tab>

                </tabset>
            </div>
        </div>
    </div>
</div>
